import { NativeError, RuntimeError } from '@belimo-retrofit-portal/logic';
import { SagaIterator } from 'redux-saga';
import { decodeOrThrow } from 'src/io/utils/decodeOrThrow';
import { makeRestRequest } from 'src/modules/api/sagas/utils/makeRestRequest';
import { PARTNER_DASHBOARD_DATA } from 'src/modules/partner-dashboard/codecs/PartnerDashboardData';
import { PartnerDashboardData } from 'src/modules/partner-dashboard/types/PartnerDashboardData';
import { call } from 'typed-redux-saga';

export function* loadPartnerDashboard(): SagaIterator<PartnerDashboardData> {
  try {
    const { content } = yield* call(makeRestRequest, 'GET', '/account/partner-dashboard');
    return yield* call(decodeOrThrow, PARTNER_DASHBOARD_DATA, content);
  } catch (error) {
    throw new RuntimeError('Could not load partner dashboard', {}, NativeError.wrap(error));
  }
}
